import { Construction } from 'lucide-react';

export function ComingSoon({ title, phase, description }: { title: string; phase: number; description: string }) {
  return (
    <section className="coming-soon card parchment-card">
      <div className="coming-icon"><Construction size={28} /></div>
      <p className="eyebrow">Phase {phase}</p>
      <h1>{title}</h1>
      <p>{description}</p>
      <div className="status-line"><span />Architecture reserved. Functionality has not been faked.</div>
    </section>
  );
}
